// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1y0yB","error":"Textarea_error__3eH6Y","readonly":"Textarea_readonly__oMufY","disabled":"Textarea_disabled__9RJqR"};